/* eslint-disable quote-props */
import { Box, styled } from "@mui/material";

import { defaultTheme } from "../../../styles/muiTheme";

export const ReasonForVisitContainerStyled = styled(Box)({
  "display": "flex",
  "alignItems": "flex-start",
  "gap": "1rem",
  "borderRadius": "0.75rem",
  "background": defaultTheme.palette.white.main,
  "border": "1px solid",
  "borderColor": defaultTheme.palette.taupe.dark,
  ".childContainer": {
    display: "flex", flexDirection: "column", gap: "0.75rem", alignItems: "flex-start",
  },
});

export const BookingWhenContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  padding: "0 0.75rem",
  alignItems: "center",
  alignSelf: "stretch",
  borderRadius: "0.75rem",
  border: "1px solid",
  background: defaultTheme.palette.white.main,
  borderColor: defaultTheme.palette.taupe.dark,
});

